import domReady from '@wordpress/dom-ready';

domReady(() => {
  function scaleAdWrappers() {
    document.querySelectorAll('.vtx-ad-wrapper').forEach((wrapper) => {
      const adWidth = parseInt(wrapper.dataset.adWidth, 10);
      const adHeight = parseInt(wrapper.dataset.adHeight, 10);
      const inner = wrapper.firstElementChild;

      if (!adWidth || !adHeight || !inner) return;

      // Apply only on mobile (max 768px)
      if (window.innerWidth <= 768) {
        const availableWidth = wrapper.offsetWidth;

        if (availableWidth < adWidth) {
          const scale = availableWidth / adWidth;

          inner.style.transform = `scale(${scale})`;
          inner.style.transformOrigin = 'top left';
          wrapper.style.height = Math.round(adHeight * scale) + 'px';
        }
      } else {
        // Reset on desktop
        inner.style.transform = '';
        inner.style.transformOrigin = '';
        wrapper.style.height = '';
      }
    });
  }

  scaleAdWrappers();
  window.addEventListener('resize', scaleAdWrappers);
});
